export default () => ({
  healthPlanTasks: null,
  counters: {},
  selectedFilters: {
    status: [],
    group: [],
    type: [],
    releasedBy: [],
    demand: []
  }
})
